import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Calendar } from '../ui/calendar';
import { Label } from '../ui/label';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Calendar as CalendarIcon } from 'lucide-react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

export const STATUT_LABELS = {
    // Current backend keys (models.py STATUTS_PIPELINE)
    nouveau_prospect: 'Nouveau prospect',
    rdv_planifie: 'RDV planifié',
    relance: 'Relance',
    devis_envoye: 'Devis envoyé',
    accepte: 'Accepté',
    chantier_en_cours: 'Chantier en cours',
    chantier_termine: 'Chantier terminé',
    refuse: 'Refusé',
    // Legacy keys kept for backward compat (older dossiers may still reference them)
    a_qualifier: 'À qualifier',
    rdv_a_planifier: 'RDV à planifier',
    devis_a_faire: 'Devis à faire',
    relance_a_faire: 'Relance à faire',
    devis_accepte: 'Devis accepté',
    devis_refuse: 'Devis refusé',
    chantier_planifie: 'Chantier planifié',
    reception_effectuee: 'Réception effectuée',
    satisfaction_envoyee: 'Satisfaction envoyée',
    avis_google_demande: 'Avis Google demandé',
    parrainage_obtenu: 'Parrainage obtenu',
    dossier_clos: 'Dossier clos'
};

export const DOCUMENT_TYPES = [
    { value: 'devis', label: 'Devis' },
    { value: 'plan', label: 'Plan' },
    { value: 'photo_avant', label: 'Photo avant' },
    { value: 'photo_pendant', label: 'Photo pendant' },
    { value: 'photo_apres', label: 'Photo après' },
    { value: 'email', label: 'Email' },
    { value: 'compte_rendu', label: 'Compte rendu' },
    { value: 'administratif', label: 'Document administratif' }
];

export const DateField = ({ label, value, onChange, field, onAutoSave }) => {
    const [open, setOpen] = useState(false);
    const dateValue = value ? new Date(value) : undefined;

    return (
        <div className="space-y-1">
            <Label className="field-label">{label}</Label>
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild>
                    <Button
                        variant="outline"
                        className="w-full justify-start text-left font-normal h-10 rounded-sm"
                        data-testid={`date-${field}`}
                    >
                        <CalendarIcon className="mr-2 h-4 w-4" />
                        {dateValue ? format(dateValue, 'dd/MM/yyyy', { locale: fr }) : 'Sélectionner'}
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0 bg-white" align="start">
                    <Calendar
                        mode="single"
                        selected={dateValue}
                        onSelect={(date) => {
                            const iso = date ? date.toISOString() : null;
                            onChange(field, iso);
                            setOpen(false);
                            if (onAutoSave) onAutoSave(field, iso);
                        }}
                        locale={fr}
                    />
                </PopoverContent>
            </Popover>
        </div>
    );
};
